// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Divider from "@mui/material/Divider";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
//import DefaultCounterCard from "examples/Cards/CounterCards/DefaultCounterCard";
import bgFront from "assets/images/EastCoastBanner.jpeg";
import bgBack from "assets/images/water-underBack.jpeg";
import bgFront2 from "assets/images/B2.jpeg";
import bgFront3 from "assets/images/diving-contactHome.jpeg";
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";
//import MKTypography from "components/MKTypography";
import MKBadge from "components/MKBadge";

function Counters() {
  return (
    <MKBox component="section" py={6} my={2}>
      <Container>
        <Grid container item xs={11} spacing={1} alignItems="center" sx={{ mx: "auto" }}>
          <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront}
                //icon="touch_app"
                title={
                  <>
                    East Coast
                    <br />
                  </>
                }
                description="May to October"
              />
              <RotatingCardBack
                image={bgBack}
                title="Discover More"
                description="Dive among a vibrant variety of coral fish, graceful turtles, and many other amazing sights beneath the sea."
                action={{
                  type: "internal",
                  route: "/pages/landing-pages/locations/east-coast",
                  label: "more details",
                }}
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront2}
                //icon="touch_app"
                title={
                  <>
                    West Coast
                    <br />
                  </>
                }
                description="November to April"
              />
              <RotatingCardBack
                image={bgBack}
                title="Discover More"
                description="Dive among a vibrant variety of coral fish, graceful turtles, and many other amazing sights beneath the sea."
                action={{
                  type: "internal",
                  route: "/pages/landing-pages/locations/west-coast",
                  label: "more details",
                }}
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront3}
                //icon="touch_app"
                title={
                  <>
                    Book your dive
                    <br />
                  </>
                }
                description="Contact us"
              />
              <RotatingCardBack
                image={bgBack}
                title="Discover More"
                description="Dive among a vibrant variety of coral fish, graceful turtles, and many other amazing sights beneath the sea."
                action={{
                  type: "internal",
                  route: "/pages/landing-pages/contact-us",
                  label: "more details",
                }}
              />
            </RotatingCard>
          </Grid>
          <Container>
            <Grid
              container
              item
              xs={20}
              lg={16}
              flexDirection="column"
              alignItems="center"
              sx={{ textAlign: "center", my: 4, mx: "auto", px: 0.75 }}
            >
              <MKBadge
                variant="contained"
                color="info"
                badgeContent="dive with a smile..."
                container
                sx={{ mb: -25 }}
              />
            </Grid>
          </Container>
        </Grid>
      </Container>
    </MKBox>
  );
}
export default Counters;
